export const blockIconsCommunicationSendNew = (
	<span className='material-symbols-outlined'>send</span>
);
